import { ContentBlock } from "./contentBlock";
import { ImageAsset } from "./imageAsset";

export type ImageCollage = {
    id: string;
    _type: 'imageCollage';
    images: ImageAsset[];
    mobileImages?: ImageAsset[];
}

export const isImageCollage = (solution: ContentBlock): solution is ImageCollage => {
    return solution._type === 'imageCollage';
}